import { createContext, useContext, useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../firebase';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [userProfile, setUserProfile] = useState(null);
  const [isHqAdmin, setIsHqAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    return onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        setUser(firebaseUser);

        const tokenResult = await firebaseUser.getIdTokenResult();
        const hqAdmin = tokenResult.claims.isHqAdmin === true;
        setIsHqAdmin(hqAdmin);

        try {
          const userDoc = await getDoc(doc(db, 'users', firebaseUser.uid));
          if (userDoc.exists()) {
            setUserProfile({ uid: firebaseUser.uid, ...userDoc.data() });
          } else {
            setUserProfile({ uid: firebaseUser.uid, email: firebaseUser.email, name: firebaseUser.email });
          }
        } catch (e) {
          setUserProfile({ uid: firebaseUser.uid, email: firebaseUser.email, name: firebaseUser.email });
        }
      } else {
        setUser(null);
        setUserProfile(null);
        setIsHqAdmin(false);
      }
      setLoading(false);
    });
  }, []);

  return (
    <AuthContext.Provider value={{
      user,
      userProfile,
      isHqAdmin,
      loading,
      isAuthenticated: !!user && isHqAdmin,
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
